/*eslint no-magic-numbers: ["error", { "ignore": [16] }]*/
import { pxToRem } from '@affinidi/component-library'
import styled from 'styled-components'

export const Text = styled.span`
  display: flex;
  flex-direction: column;
  row-gap: ${pxToRem(16)};
`
